import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import InfiniteList from '@comp/InfiniteList/InfiniteList';
import FreeCourseCard from '@comp/FreeCourseCard/FreeCourseCard';
import { useDispatchToStore } from '@hooks/reduxHooks';
import { fetchFreeCoursesOfAConcept } from '@actions/topologies';
import { toggleBookmarkItem } from '@actions/courses';
import { Spacings } from '../../../styleConstants';

const StyledFreeCourseCard = styled(FreeCourseCard)`
  margin-bottom: ${Spacings.SPACING_6B};
`;
const FreeTopicCourses = ({ topicUid, courseData, dataAnalytics }) => {
  const dispatch = useDispatchToStore();
  const handleSaveUnSave = (courseUID, isBookmarked) => {
    dispatch(toggleBookmarkItem(courseUID, 4, isBookmarked));
  };

  const loadMoreCourses = () => {
    return dispatch(fetchFreeCoursesOfAConcept(topicUid, true));
  };

  const renderFeedBlock = (course, index) => {
    return (
      <StyledFreeCourseCard
        index={index}
        dataAnalytics={dataAnalytics}
        key={course.uid}
        course={course}
        onClickSave={handleSaveUnSave}
      />
    );
  };

  return (
    <>
      <InfiniteList
        data={courseData}
        loadMore={loadMoreCourses}
        _renderItem={renderFeedBlock}
      />
    </>
  );
};

FreeTopicCourses.propTypes = {
  topicUid: PropTypes.string.isRequired,
  courseData: PropTypes.objectOf(PropTypes.any).isRequired,
  dataAnalytics: PropTypes.string.isRequired
};

export default FreeTopicCourses;
